/** @format */

// GET_USER
export const GET_ORDER = "GET_ORDER";

// GET_ORDER_DETAIL
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL";

// UPDATE_ORDER

export const UPDATE_ORDER = "UPDATE_ORDER";

// CONFIRM_COD_PAYMENT

export const CONFIRM_COD_PAYMENT = "CONFIRM_COD_PAYMENT";
